import { SEASONS, type Lang, type SeasonContent, type SeasonKey } from '../content/seasons';

/**
 * A build-időben eldöntött szezon (vite.config.ts → define: __SEASON__).
 * Szándékosan NEM a böngésző dátuma: a statikus hero-héj és a JSON-LD ugyanebből épül,
 * a React-nek ugyanazt kell renderelnie, különben villan és az LCP romlik.
 * Előnézethez: `VITE_SEASON=winter npm run dev`.
 */
export const CURRENT_SEASON: SeasonKey = __SEASON__;

export function seasonContent(lang: Lang): SeasonContent {
  return SEASONS[lang][CURRENT_SEASON];
}
